export const DOCTOR_PROFILE_CONSTANTS = {
  BANNER: {
    WELCOME_TITLE: "Bienvenido, Dr.",
    WELCOME_TEXT: "Aquí tiene su agenda del día",
    NO_EVENTS_FOUND:
      "No hay eventos disponibles actualmente. Vuelva a comprobarlo pronto"
  },
  TEXTS: {
    TODAY: "Hoy"
  },
  EVENTS: "{0} Eventos"
};

export const CALENDAR_TYPE = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month"
};

export const CONFIGURATIONS = {
  VIEW_TYPES: [
    { label: "Mes", value: "month" },
    { label: "Semana", value: "week" },
    { label: "Día", value: "day" }
  ]
};

export const MESSAGES = {
  MEDICALAPPOINTMENT_FOUND: "cita médica existente"
};

export const AGENDA_CONSTANTS = {
  AVAILABLE: "Disponible",
  BLOCKED: "Bloqueado",
  RESERVED: "Reservado",
  NO_AVAILABLE: "No disponible",
  AVAILABLE_COLOR: "#2770E8",
  BLOCKED_COLOR: "#277099",
  CANCEL_COLOR: "#9E9E9E",
  RESERVED_COLOR: "#277099",
  NO_ASIGNATION: "Sin asignar",
  CANCEL: "Cancelado",
  BUSY: "Ocupado"
};

export const DOCTOR_PROFILE_ACCESS = {
  GET: "consultar citas"
};

export const CONFIMARTION_MODAL_CONTANTS = {
  PROFILE_TITLE: "Redirecionar al perfil",
  SERVICIO_TITLE: "Salir de la agenda",
  MESSAGE: "Esta por salir de la pantalla de agenda ¿Desea continuar?"
};
